import React from "react";
import {
  ConsultantStatus,
  ConsultantEditor_UpdateStatusComponent
} from "@graphql";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import locale from "@bonliva-crm/locale";
import { store } from "@store";

type ToggleProps = {
  status: ConsultantStatus;
  disabled: boolean;
  id: string;
};

export const ToggleMarkForDelete = ({ status: original, disabled, id }: ToggleProps) => {
  const tbd = ConsultantStatus.ToBeDeleted;
  const resetStatus = original === tbd ? ConsultantStatus.Active : original;

  return (
    <ConsultantEditor_UpdateStatusComponent>
      {(x, { data, loading }) => {
        const currentStatus = data ? data.updateConsultantStatus.Status : original;
        const status = currentStatus === tbd ? resetStatus : tbd;
        return (
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={currentStatus === tbd}
                disabled={disabled || loading}
                onChange={() => {
                  return x({ variables: { id, status } })
                    .then(() => {
                      store().snackbars.success(
                        locale.ConsultantStatusChangeSuccess(status)
                      );
                    })
                    .catch((e) => {
                      store().snackbars.error(
                        `Cannot change consultant status\nReason: ${e}`
                      );
                    });
                }}
              />
            }
            data-test={"MarkAsDeletedButton"}
            label={locale.MarkAsDeleted}
          />
        );
      }}
    </ConsultantEditor_UpdateStatusComponent>
  );
};
